import React, { useState, useEffect } from 'react';
import Cs from '../../../services/CommonService';
import { useCurrentUserHook } from '../../Authentication/useUserHook';
import DigitalContentService from '../../DigitalContent/DigitalContentService';

const upcomingEvents = [
  { id: 1, title: 'Greater Metro Chamber of Commerce 2025', date: 'March 15th, 2025', tag: 'Business' },
  { id: 2, title: 'Wednesday Potluck Networking Dinner',    date: 'March 20th, 2025', tag: 'Social'   },
  { id: 3, title: 'Annual Innovation Summit 2025',          date: 'April 5th, 2025',  tag: 'Conference'},
];

const goals = [
  { label: 'March 2025 Donations', target: '$300.00',   collected: '$221.34', pct: 63, barClass: 'bg-lightblue' },
  { label: 'Event Fundraising',    target: '$1,500.00', collected: '$221.34', pct: 15, barClass: 'bg-green'     },
];

const activity = [
  { icon: 'fas fa-exclamation-circle', wrapClass: 'bg-yellow-white color-yellow1-dark', text: 'You have a recent payment that did not process',                     time: '4 HOURS AGO' },
  { icon: 'fas fa-calendar-check',     wrapClass: 'bg-blue-white color-highlight',      text: 'You registered for an event, Greater Metro Chamber of Commerce 2025', time: '2 DAYS AGO'  },
  { icon: 'fas fa-dollar-sign',        wrapClass: 'bg-pale-green color-green1-dark',    text: 'You made a payment of $34.99 to your membership account',             time: '5 DAYS AGO'  },
  { icon: 'fas fa-envelope',           wrapClass: 'bg-voilet text-voilet',              text: 'You received a message from Alex Johnson',                            time: '7 DAYS AGO'  },
];

const connections = [
  { initials: 'AJ', bg: 'bg-username'    }, { initials: 'SM', bg: 'bg-instagram'  },
  { initials: 'RK', bg: 'bg-green'       }, { initials: 'TP', bg: 'bg-safforn'    },
  { initials: 'NL', bg: 'bg-voilet'      }, { initials: 'DW', bg: 'bg-lred'       },
  { initials: 'CG', bg: 'bg-lblue'       }, { initials: 'MH', bg: 'bg-lgreen'     },
  { initials: 'JB', bg: 'bg-bemedian'    }, { initials: 'KR', bg: 'bg-activity'   },
  { initials: 'OT', bg: 'bg-light-green' }, { initials: 'PV', bg: 'bg-light-orange'},
];

const agentPrices = [
  { category: 'Office Space (per sqft)', market: '$42.50',    analyzed: '$38.20',    delta: '-10%', positive: true  },
  { category: 'Commercial Lease',        market: '$3,200/mo', analyzed: '$2,900/mo', delta: '-9%',  positive: true  },
  { category: 'Retail Storefront',       market: '$5,800/mo', analyzed: '$6,100/mo', delta: '+5%',  positive: false },
];

const agentBlogPosts = [
  {
    title: 'AI-Powered Price Analysis: How Startup Agents Are Disrupting Commercial Real Estate',
    date: 'Apr 20, 2025', category: 'Market Analysis', readTime: '5 min read',
    excerpt: 'Our agent engine analyzed over 12,000 commercial listings this quarter to surface pricing gaps that human analysts miss.',
  },
  {
    title: 'From Data to Decision: The Startup Agent Workflow Explained',
    date: 'Apr 15, 2025', category: 'Product Update', readTime: '4 min read',
    excerpt: "We've rebuilt our analysis pipeline to deliver insights in real time. The new Startup Agent workflow ingests live MLS feeds and surfaces actionable deltas within seconds.",
  },
  {
    title: 'Case Study: How Acme Corp Saved 9% on Commercial Lease Costs',
    date: 'Apr 10, 2025', category: 'Case Study', readTime: '3 min read',
    excerpt: "Using the Price Analyzer agent, Acme Corp's facilities team identified a $2,900/mo lease opportunity against a $3,200/mo market average.",
  },
];


const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const ListRow = ({ children }) => (
  <div className="flex justspacebetween aligncenter p-t-10 p-b-10 br-btm-grey">{children}</div>
);

const GreenBtn = ({ label = 'View', onClick, extraClass = '' }) => (
  <button className={`btn-primary bg-green1-dark text-white brd-5 font-12 fw500 p-5-10 ${extraClass}`} onClick={onClick}>
    {label}
  </button>
);

const DashboardTab = ({ orgRegistration, onNavigate, memberPortalIds = [] }) => {
  const { currentUser } = useCurrentUserHook();
  const [bannerOn,        setBannerOn]        = useState(true);
  const [agentTab,        setAgentTab]        = useState('insights');
  const [whatsNewPosts,   setWhatsNewPosts]   = useState([]);
  const [whatsNewLoading, setWhatsNewLoading] = useState(true);

  useEffect(() => {
    const filter = { organization_id: currentUser.current_organization_id };
    if (memberPortalIds && memberPortalIds.length > 0) {
      filter.member_portal_ids = memberPortalIds;
    }
    DigitalContentService.getAll({
      page: 1, per_page: 3,
      sort_column: 'record_id', sort_direction: 'desc',
      content_type: 'whats_new',
      filter,
    }).then((res) => {
      setWhatsNewPosts(res.data.digital_contents || []);
      setWhatsNewLoading(false);
    }).catch(() => setWhatsNewLoading(false));
  }, []);

  const {data:regInfo={}} = orgRegistration;

  return (
    <>
      {bannerOn && (
        <div className="flex justspacebetween aligncenter brd-10 p-20 m-b-20 grad-teal-blue">
          <div>
            <div className="fw700 font-18 text-white">2025 Innovation Conference</div>
            <div className="font-13 text-white op-09 m-t-5">Interesting speakers, delicious food — don't miss this event!</div>
          </div>
          <div className="flex aligncenter gap-10">
            <button className="bg-white color-green1-dark brd-8 fw700 font-14 p-10 p-l-20 p-r-20">Sign Up Today!</button>
            <button className="bg-white brd-50p circle-sm-2 fw700 font-16 color-grey pointer" onClick={() => setBannerOn(false)}>×</button>
          </div>
        </div>
      )}

      <div className="flex gap-20 alignstart">
        <div className="dashboard-left-col flex-shrink">
          <div className="bg-white brd-10 shadow-small overflow m-b-20">
            <div className="cover-gradient ht-90"></div>
            <div className="p-l-20 p-r-20 avatar-pull">
              <div className="circle-avatar-lg flex aligncenter justifycenter fw700 f28 text-white bg-blue-dark br-white">{regInfo.prim_contact?.[0]}</div>
            </div>
            <div className="p-10 p-l-20 p-r-20 p-b-20">
              <div className="flex justspacebetween alignstart">
                <div>
                  <div className="fw700 font-18 dark-navy">Welcome, {regInfo.prim_contact}</div>
                  <div className="font-12 lgrey m-t-2">Profile ID: {orgRegistration.record_id}</div>
                </div>
                <span className="font-12 highlight pointer fw500">Edit Profile</span>
              </div>
              <div className="m-t-14 font-13 lh-19">
                <div className="fw500 dark-navy m-b-5">[{regInfo.name}]</div>
                <div className="flex gap-10 aligncenter m-t-2"><i className="fas fa-map-marker-alt highlight"></i><span>{regInfo.state}, {regInfo.country_code}</span></div>
                <div className="flex gap-10 aligncenter m-t-2"><i className="fas fa-phone green"></i><span>{regInfo.prim_mobile || regInfo.telephone}</span></div>
                <div className="flex gap-10 aligncenter m-t-2"><i className="fas fa-envelope text-voilet"></i><span>{regInfo.prim_email}</span></div>
                <div className="m-t-10 font-12">
                  <span className="lgrey">Joined: {Cs.formatUpdateDate(orgRegistration.created_at)} &nbsp;&nbsp;</span>
                  <span className="red fw500">Expires: {Cs.formatUpdateDate('2026-12-30')}</span>
                </div>
              </div>
              <button className="bg-green1-dark text-white brd-8 fw700 font-14 w-100p p-10 m-t-15 no-border pointer">Renew Membership</button>
            </div>
          </div>

          <SectionCard>
            <CardHeader title="Connections" action="Find" />
            <div className="flex wrap gap-8">
              {connections.map((c, i) => (
                <div key={i} className={`circle-avatar-sm flex aligncenter justifycenter fw700 font-12 text-white ${c.bg}`}>{c.initials}</div>
              ))}
            </div>
          </SectionCard>
        </div>

        <div className="flex-grow">
          <div className="font-11 lgrey fw700 text-upp ls-1 m-b-10">[ASSOCIATION NAME]</div>
          <div className="flex gap-20 m-b-0">
            <SectionCard extraClass="flex-grow">
              <CardHeader title="Upcoming Events" action="All Upcoming" />
              {upcomingEvents.slice(0, 2).map(ev => (
                <ListRow key={ev.id}>
                  <div>
                    <div className="fw500 font-13 dark-navy">{ev.title}</div>
                    <div className="font-12 lgrey m-t-2">{ev.date}</div>
                  </div>
                  <GreenBtn />
                </ListRow>
              ))}
            </SectionCard>

            <SectionCard extraClass="flex-grow">
              <CardHeader title="Projects" action="Start New Project" onAction={() => onNavigate('projects')} />
              {goals.map((g, i) => (
                <div key={i} className={i < goals.length - 1 ? 'm-b-15' : ''}>
                  <div className="flex justspacebetween font-13">
                    <span className="fw500">{g.label}</span>
                    <span className="fw700 dark-navy">{g.target}</span>
                  </div>
                  <div className="progress-track m-t-5 m-b-3">
                    <div className={`progress-fill ${g.barClass}`} style={{ width: `${g.pct}%` }}></div>
                  </div>
                  <div className="flex justspacebetween font-11 lgrey">
                    <span>{g.collected} collected! {g.pct}% of your goal.</span>
                    <span className="highlight pointer fw500">Details</span>
                  </div>
                </div>
              ))}
            </SectionCard>
          </div>

          <SectionCard>
            <CardHeader title="Startup Agent Activity" action="All Activity" />
            <div className="flex gap-5 m-b-15 br-btm-grey p-b-10">
              {['activity', 'insights', 'blog'].map(tab => (
                <button key={tab}
                  className={`brd-5 font-12 fw500 p-5-10 no-border pointer ${agentTab === tab ? 'bg-green1-dark text-white' : 'bg-grey-1 color-black'}`}
                  onClick={() => setAgentTab(tab)}>
                  {tab === 'activity' ? 'Activity Feed' : tab === 'insights' ? 'Agent Insights' : 'Agent Blog'}
                </button>
              ))}
            </div>

            {agentTab === 'activity' && activity.map((a, i) => (
              <ListRow key={i}>
                <div className="flex aligncenter gap-15 flex-grow">
                  <div className={`circle-avatar-sm flex aligncenter justifycenter flex-shrink brd-50p ${a.wrapClass}`}>
                    <i className={`${a.icon} font-15`}></i>
                  </div>
                  <div>
                    <div className="font-13 color-black">{a.text}</div>
                    <div className="font-11 lgrey m-t-2">{a.time}</div>
                  </div>
                </div>
                <GreenBtn />
              </ListRow>
            ))}

            {agentTab === 'insights' && (
              <div className="table-responsive">
                <table className="table shadow-small">
                  <thead><tr>{['Category', 'Market Price', 'Analyzed Price', 'Delta'].map(h => <th key={h}>{h}</th>)}</tr></thead>
                  <tbody>
                    {agentPrices.map((row, i) => (
                      <tr key={i}>
                        <td>{row.category}</td>
                        <td className="lgrey">{row.market}</td>
                        <td className="fw500 dark-navy">{row.analyzed}</td>
                        <td><span className={`fw700 ${row.positive ? 'green' : 'red'}`}>{row.delta}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {agentTab === 'blog' && agentBlogPosts.map((post, i) => (
              <div key={i} className="flex coldir gap-5 p-t-12 p-b-12 br-btm-grey">
                <div className="flex aligncenter gap-8 m-b-4">
                  <span className="badge-3 bg-blue-white color-highlight">{post.category}</span>
                  <span className="font-11 lgrey">{post.readTime}</span>
                </div>
                <div className="fw500 font-14 dark-navy">{post.title}</div>
                <div className="font-12 lgrey lh-19">{post.excerpt}</div>
                <div className="flex justspacebetween aligncenter m-t-4">
                  <span className="font-11 lgrey">{post.date}</span>
                  <GreenBtn label="Read More" />
                </div>
              </div>
            ))}
          </SectionCard>

          <SectionCard>
            <CardHeader title="What's New" action="See All" onAction={() => onNavigate('whats_new')} />
            {whatsNewLoading ? (
              <div className="flex aligncenter justifycenter p-20">
                <i className="fas fa-spinner fa-spin font-18 color-grey"></i>
              </div>
            ) : whatsNewPosts.length === 0 ? (
              <div className="font-13 lgrey p-10 text-center">No posts yet.</div>
            ) : (
              whatsNewPosts.map((post, i) => (
                <div key={post.id || i} className="flex coldir gap-4 p-t-10 p-b-10 br-btm-grey pointer"
                  onClick={() => onNavigate('whats_new')}>
                  <div className="flex aligncenter gap-8">
                    <span className="badge-3 bg-yellow-white color-yellow1-dark">
                      <i className="fas fa-bell m-r-4"></i>What's New
                    </span>
                    <span className="font-11 lgrey">{Cs.formatUpdateDate(post.created_at)}</span>
                  </div>
                  <div className="fw500 font-13 dark-navy">{post.data?.heading || '(No heading)'}</div>
                  {post.data?.body_text && (
                    <div className="font-12 lgrey ellipsis-2"
                      dangerouslySetInnerHTML={{ __html: post.data.body_text }} />
                  )}
                </div>
              ))
            )}
          </SectionCard>
        </div>
      </div>
    </>
  );
};

export default DashboardTab;